import { TemplateEditViews } from '../common/types';
import { useQueryParamContext } from '../context/QueryParamContext';
import { Content } from './Content';
import { EditEmailContext } from './context/EditMailContext';
import PreviewWithData from './PreviewWithData';
import Settings from './Settings';

const renderView = (view: string) => {
  // The Content component is always rendered to prevent reloading of the editor when switching views
  return (
    <>
      <Content isVisible={view === TemplateEditViews.content} />
      {view === TemplateEditViews.preview && <PreviewWithData />}
      {view === TemplateEditViews.settings && <Settings />}
    </>
  );
};

export const EditEmail = () => {
  const { view } = useQueryParamContext();

  return <EditEmailContext>{renderView(view)}</EditEmailContext>;
};

export default EditEmail;
